/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";
import schedulesViewStateStore from "../../store/store";

/**
 * Clear the members filter list
 */
export const clearFilteredMembers = mutatorAction(
    "clearFilteredMembers",
    () => {
        schedulesViewStateStore().filteredMembers.clear();
    }
);